import { Container, Grid, Group, Text, Image, Box, useMantineTheme, ScrollArea } from '@mantine/core';
import { useElementSize, useMediaQuery } from '@mantine/hooks';
import clamorText from '../assets/logos/clamorText.svg';
import { Content } from '../config/Constant';
import { aboutImge } from '../assets';

const About = () => {
  const mantinetheme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${mantinetheme.breakpoints.sm})`);
  const { ref, height } = useElementSize();

  return (
    <>
      <Container>
        <div ref={ref}>
          <Grid m={0} pb={5}>
            <Grid.Col ml={-10} mt={-15} span={2}>
              <Text fz='16px' fw={500} color='black'>
                ABOUT CLAMOR
              </Text>
            </Grid.Col>
          </Grid>
        </div>

        <ScrollArea.Autosize type='never' mah={window.innerHeight - (height + 90)}>
          <Group position='center' pt='10px'>
            <Image width='auto' height='auto' src={aboutImge} />
          </Group>

          <Box>
            <Text pt='20px' fw={450} fz={mobile ? '11px' : '13px'} color='black' align='left'>
              {Content.aboutContentOne}
            </Text>
            <Text pt='10px' fw={450} fz={mobile ? '11px' : '13px'} color='black' align='left'>
              {Content.aboutContentTwo}
            </Text>
          </Box>

          <Box pt='40px' fw={450}>
            <Image width='auto' height='auto' src={clamorText} />
            <Text pt='5px' fw={500} fz={mobile ? '12px' : '14px'} color='#000000;' align='left'>
              88 Market Drive
            </Text>
            <Text fz={mobile ? '12px' : '14px'} fw={500} color='#000000;' align='left'>
              Santa Ana, CA 92703
            </Text>
          </Box>
        </ScrollArea.Autosize>
      </Container>
    </>
  );
};

export default About;
